module.exports = __webpack_public_path__ + "media/promo/velle/images/article__mob-4ebe24a1c9f8273f9c4f8c8f4255329f.jpg";